export default {
    setCenter (state, center) {
        state.center = center
    },
}
